<div class="fb-video" [attr.data-href]="streamKey" data-allowfullscreen="true" data-width="500"></div>
